export const getBaseDomain = (host) => {
    const parts = (host || '').split('.').filter(Boolean);
    return parts.length >= 2 ? parts.slice(-2).join('.') : host || '';
  };
  
  const getConfiguredSubprefix = (host) => {
    const parts = (host || '').split('.').filter(Boolean);
    // sve sem poslednja 2 su subdomenski prefiks (npr. ["server","rocketman"])
    return parts.length > 2 ? parts.slice(0, -2).join('.') : parts.slice(0, -2).join('.');
  };
  
  export const makeDynamicUrlPreserveProtoPort = (configuredUrl) => {
    try {
      if (typeof window !== 'undefined') {
        const feHost = window.location.hostname;
        if (feHost === 'localhost' || feHost === '127.0.0.1') {
          return configuredUrl;
        }
      } else {
        return configuredUrl;
      }
  
      const u = new URL(configuredUrl);
      const feBase = getBaseDomain(window.location.hostname);
      const subprefix = getConfiguredSubprefix(u.hostname);
      const newHost = subprefix ? `${subprefix}.${feBase}` : feBase;
      u.hostname = newHost;
  
      let urlStr = u.toString();
      // ako nema path/query/hash i završava se samo sa '/', ukloni je
      if (urlStr.endsWith('/') && u.pathname === '/' && !u.search && !u.hash) {
        urlStr = urlStr.slice(0, -1);
      }
      return urlStr;
    } catch {
      return configuredUrl;
    }
  };
  